import type { DSDReportListItemResponse } from "@/apis/dsd-editor/types";
import { parseServerUtcDate } from "@/utils/time";

export const formatUploadedAt = (uploadedAt: string): string => {
  const uploadedAtDate = parseServerUtcDate(uploadedAt);
  const time = uploadedAtDate.getTime();

  if (Number.isNaN(time)) return uploadedAt;

  return uploadedAtDate.toLocaleString("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getReportMetaLabel = (report: DSDReportListItemResponse) =>
  [report.year, report.period, report.reportType].filter(Boolean).join(" · ");

export const getReportPageWindow = <Report>(
  reports: Report[],
  pageSize: number,
) => ({
  visibleReports: reports.slice(0, pageSize),
  hasNextReportPage: reports.length > pageSize,
});
